import Lottie from 'react-lottie-player';
import LoadingAnimationDots from '../../assets/animations/LoadingAnimationDots.json';

export interface Props {
  src?: object;
  style?: object;
  className?: string;
}

export default function CustomLoadingIndicator({ src = LoadingAnimationDots, style = {}, className = null }: Props) {
  return (
    <Lottie
      animationData={src}
      play
      loop
      style={style}
      className={className}
      rendererSettings={{
        preserveAspectRatio: 'xMidYMid slice',
      }}
    />
  );
}
